import { Page } from '../../types'

const addDetectedError: Page[] = [
    {
        pageType: 'question',
        title: 'Detected error',
        name: 'detected-error',
        description:
            'This section refers to all instances of fraud, error or bribery that were detected (after the event) in the given quarter. Instances should be reported in the CDR in the quarter it was determined to be fraud, error or bribery. For example, where a fraud occurred in quarter 2 but was undetected until quarter 4, this would be included in the Q4 return. All instances of detected fraud, error or bribery should refer to actual instances and values, not estimates.\n'+
            'Detected Fraud should be reported at the point at which it has been determined fraud, on the civil balance of probabilities, regardless of whether prosecution to the criminal standard is being progressed. This can include instances where fraud is proven to both the civil and criminal standards simultaneously.\n'+
            'Please note: All entries in this section must be attributed to a selection from the typology dropdowns. Please refer to the Typologies Definition document for more detail',
        questions: [
            {
                questionType: 'radio',
                title: 'Do you have any instances of detected error to declare?',
                name: 'detected-error-declare',
                options: ['Yes', 'No'],
                rules: {
                    required: true
                }
            }
        ]
    },
    {
        pageType: 'list',
        title: 'Add an instance',
        name: 'deducted-error-add-instance',
        description:
            'This typology refers to the amount of error detected within the given quarter. For reporting purposes, this should not include instances of error that were prevented after the point of detection (these should be reported in Section 2). Entries should include the number of instances and the value of the loss relating to the error.\n' +
            'Error should be reported on the following basis:\n'+
            '<ul><li>where it cannot be determined (upon the civil balance of probabilities) that the instance(s) involved fraud.</li><li>includes wrong or incorrect payments made to recipients, for example, overpayment to a funding recipient.</li><li>does not include losses arising from wasteful spend, inefficiencies, nugatory spend or ex-gratia payments, for example, late payment fees incurred by the Department/ALB.</li></ul><br/>'+
            'Entries must include selections from the following typology dropdowns:'+
            '<ul><li>the business area in which the error occurred</li><li>the error origin - who was responsible for the mistake (error)?</li><li>whether or not the error related to a COVID-19 scheme or activity</li></ul><br/>',
        disabled: [
            {
                field: 'detected-error-declare',
                condition: 'equals', // optional
                value: 'No'
            }
        ],
     questions: [
            {
                questionType: 'select',
                title: 'Which spending area did the error occur in?',
                name: 'detected-error-area',
                detailsHeading: 'Help with spending areas',
                detailsContent: ' <b>Procurement:</b> Goods or services bought by public sector organisations (including suppliers)' +
                                ' <br/><b>Personnel:</b> Employees (including contractors and agency workers).' +
                                ' <br/><b>Subsidies:</b> Support or incentives given by the government.' +
                                ' <br/><b>Grants:</b> Money given by a public sector organisation for a specific purpose.' +
                                ' <br/><b>Loans & credit guarantees:</b> Money given by a public sector organisation for a specific purpose.' +
                                ' <br/><b>Charges & other non-tax income:</b> Money owed to public sector organisations (for example, court fines or prescription fees)' +
                                ' <br/><b>Licenses and permits:</b> Personal or business licenses (for example, a Blue Badge or Surveyor license)' +
                                ' <br/><b>Tax & Duties:</b> Mandatory government charge for goods, income or services' +
                                ' <br/><b>Benefits:</b> Money given by the government to support members of the public' +
                                ' <br/><b>Special Payments:</b> Money given in unique or specific circumstances (for example, compensation)',
                options: ['Procurement','Personnel','Subsidies','Grants','Loans & credit gurantees','Charges & other non-tax income','Licences and permits','Tax & Duties','Benefits','Special payments'],
                hintOption: 'Select an option',
                rules: {
                    required: true
                },
                errorMessages: { required: 'This field is mandatory' }
            },    
            {
                name: 'detected-error-responsible',
                questionType: 'radio',
                title: 'Who was responsible for the error?',
                // hint: 'Select one option',
                detailsHeading: 'Help with error origin',
                detailsContent: ' <b>Customer:</b> a member of the public or someone acting on behalf of a business or charity.'+
                                ' <br/><b>Supplier:</b> a person or business contracted to supply a service.' +                
                                ' <br/><b>Official:</b> a government department, public body or service.'+
                                ' <br/><b>Unknown:</b> I don&apos;t know who was responsible for the error.',
                hintOption: 'Please Select',
                options: ['Customer', 'Supplier','Official','Unknown'],
                rules: {
                    required: true
                }
            },         
            {
                questionType: 'instanceInput',
                title: 'How many instances occurred?',
                name: 'detected-error-impact',
                txt: `Total number of instances`,
                rules: {
                    required: true
                }
            },
            {
                questionType: 'costInput',
                title: 'What was the value of the error?',
                name: 'detected-error-estimated-total',
                txt: `Total value`,
                rules: {
                    required: false
                }
            },            
            {
                questionType: 'textarea',
                title: 'Comments',
                name: 'detected-error-comments',
                hint: `Please ensure you do not include any personal or sensitive information`,
                rules: {
                    required: false
                }
            },   
            {
                questionType: 'radio',
                title: 'Does this relate to BAU or C19 activity?',
                hint: `You can tick both if applicable`,
                name: 'detected-error-bau-c19',
                options: ['Business as usual (BAU)', 'Covid-19 (C19)'],
                rules: { required: true }
            }, 
            {
                questionType: 'radio',
                title: 'Has this been recovered?',
                name: 'detected-error-recovered',
                hint: 'Please only select ‘yes’ if the recovery has happened within the reporting period (e.g. Q1 2024)',
                options: ['Yes', 'No']
            }
        ]
    },
]
export default addDetectedError
